<template>
    <div class="mainbusinessModuleWarp">
        <div  class="moduleTitle">流动人员人事档案管理服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label=" 1.档案专职管理员人数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  2.本科及以上学历人数：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">二、服务场所建筑面积</div>
                    <el-form-item label="3.服务场所建筑面积（平方米）：" prop="3">
                        <el-input v-model="ruleForm[3]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">三、档案库房</div>
                    <el-form-item label="4.库房建筑面积（平方米）：" prop="4">
                        <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="5.是否配置铁制档案柜：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="6.是否具备防火、防潮、防蛀、防盗、防光、防高温等设施：" prop="6">
                        <el-radio-group v-model="ruleForm[6]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="7.库房、阅档室、工作人员办公室三室分开：" prop="7">
                        <el-radio-group v-model="ruleForm[7]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="8.库房温度为14℃~24℃，相对湿度为45%~65%：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.是否设有监控设备：" prop="9">
                        <el-radio-group v-model="ruleForm[9]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="10.是否设有自动气体灭火设备：" prop="10">
                        <el-radio-group v-model="ruleForm[10]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">四、人事档案管理制度</div>
                    <el-form-item label="11.人事档案保管、保密、安全、借阅、转递等管理制度健全：" prop="11">
                        <el-radio-group v-model="ruleForm[11]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 12.员工知晓率（%）：" prop="12">
                        <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">五、档案存量</div>
                    <el-form-item label=" 13.人事档案存量（份）：" prop="13">
                        <el-input v-model="ruleForm[13]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">六、档案材料的收集、鉴别、整理、装订</div>
                    <el-form-item label="14.人事档案材料的收集、鉴别、整理符合标准要求：" prop="14">
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="15.档案装订率（%）：" prop="15">
                        <el-input v-model="ruleForm[15]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、信息化管理程度</div>
                    <el-form-item label="16.人事档案信息化程度" prop="16">
                        <el-select v-model="ruleForm[16]" placeholder="请选择">
                            <el-option label="A.手工操作" value="A"></el-option>
                            <el-option label="B.部分业务实现信息化管理" value="B"></el-option>
                            <el-option label="C.主要业务实现信息化管理" value="C"></el-option>
                            <el-option label="D.全部业务实现信息化管理" value="D"></el-option>
                            <el-option label="E.服务实现全过程信息化管理" value="E"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="bigTitle">八、服务内容</div>
                    <el-form-item label="17.提供人事档案接收、分类归档、整理保管、转出服务：" prop="17">
                        <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="18.标准规定的其他服务承办率（%）：" prop="18">
                        <el-input v-model="ruleForm[18]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">九、客户投诉记录及处理</div>
                    <el-form-item label="19.是否设有投诉电话：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="20.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="20">
                        <el-input v-model="ruleForm[20]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="21.投诉及处理情况记录保存年限（年）：" prop="21">
                        <el-input v-model="ruleForm[21]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  22.是否有投诉及处理情况记录" prop="22">
                        <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },

                ],

                3: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                7: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                10: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                11: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                21: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],

            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    let NewDataList = []
                    // this.ruleForm[16] = this.ruleForm[16].join(',')
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },

        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                        // this.ruleForm[16] = this.ruleForm[16].split(',')
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal8Warp {
}
</style>


